import { BuildingIcon, GlobeIcon, Grid2X2Icon, LineChartIcon, UserCogIcon } from 'lucide-react';

import AppSidebar from '@/components/app-layout/Sidebar';
import AppSidebarSubitems, { AppSidebarSubitem } from '@/components/app-layout/SidebarSubitems';
import { useGlobalAuthStore } from '@Stores/global/auth';

import CustomReportSidebarSection from './views/custom/components/CustomReportSidebarSection';

export default function ReportSidebar({ hasPermission }) {
  const { auth: { isSuperAdmin } } = useGlobalAuthStore()

  return <AppSidebar>
    <AppSidebarSubitems alias="Path" icon={Grid2X2Icon}>
      <AppSidebarSubitem to="/reports/impression" alias="Impression" require="path" hasPermission={hasPermission} />
      <AppSidebarSubitem to="/reports/progression" alias="Progression" require="path" hasPermission={hasPermission} />
      <AppSidebarSubitem to="/reports/finder" alias="Path Finder" require="path" hasPermission={hasPermission} />
      <AppSidebarSubitem to="/reports/failure" alias="Failure" require="path" hasPermission={hasPermission} />
      <AppSidebarSubitem to="/reports/surveys" alias="Surveys" require="path" hasPermission={hasPermission} />
      {isSuperAdmin ? <AppSidebarSubitem to="/reports/pivot-table/impression" alias="Impression Pivot Table" require="path" hasPermission={hasPermission} /> : null}
    </AppSidebarSubitems>
    <AppSidebarSubitems alias="Site" icon={GlobeIcon}>
      <AppSidebarSubitem to="/reports/session" alias="Session" require="offer" hasPermission={hasPermission} />
      {isSuperAdmin ? <AppSidebarSubitem to="/reports/pivot-table/session" alias="Session Pivot Table" require="offer" hasPermission={hasPermission} /> : null}
      <AppSidebarSubitem to="/reports/allocation" alias="URL Anomalies" require="offer" hasPermission={hasPermission} />
      <AppSidebarSubitem to="/reports/integration" alias="Integrations" require="path" hasPermission={hasPermission} />
      <AppSidebarSubitem to="/reports/site-verification" alias="Verifications" require="offer" hasPermission={hasPermission} />
      <AppSidebarSubitem to="/reports/sweep-winner" alias="Sweep Winner" require="offer" hasPermission={hasPermission} />
      <AppSidebarSubitem to="/reports/ping-check" alias="Ping Check" require="cms" hasPermission={hasPermission} />
      <AppSidebarSubitem to="/reports/rewards" alias="Rewards" require="cms" hasPermission={hasPermission} />
    </AppSidebarSubitems>
    <AppSidebarSubitems alias="Performance" icon={LineChartIcon}>
      <AppSidebarSubitem to="/reports/publisher-performance" alias="Pub Performance" require="offer" hasPermission={hasPermission} />
      <AppSidebarSubitem to="/reports/bucket" alias="Bucket" require="path" hasPermission={hasPermission} />
    </AppSidebarSubitems>
    <AppSidebarSubitems alias="Compliance" icon={UserCogIcon}>
      <AppSidebarSubitem to="/reports/optout-summary" alias="Opt-out Summary" require="cms" hasPermission={hasPermission} />
      <AppSidebarSubitem to="/reports/optouts" alias="Opt-outs" require="cms" hasPermission={hasPermission} />
      <AppSidebarSubitem to="/reports/inquiry" alias="Inquiry" require="path" hasPermission={hasPermission} />
      <AppSidebarSubitem to="/reports/audit" alias="Audit" require="path" hasPermission={hasPermission} />
    </AppSidebarSubitems>
    <AppSidebarSubitems alias="Organization" icon={BuildingIcon}>
      <AppSidebarSubitem to="/reports/organization-performance" alias="Organization Performance" require="offer" hasPermission={hasPermission} />
    </AppSidebarSubitems>
    {isSuperAdmin ? <CustomReportSidebarSection hasPermission={hasPermission} /> : null}
  </AppSidebar>
}
